import { useData } from "../../services/context/DataContext";
import { useState, useEffect, FunctionComponent } from "react";
import CreateTable from "./CreateTable";

interface Column {
  field: string;
  header: string;
  sortable?: boolean;
  filterable?: boolean;
  width?: string;
  expandable?: boolean;
  type?: "text" | "number" | "date";
}

function extractDetails(obj: any, result: any = []) {
  if (obj && typeof obj === 'object') {
    if (Array.isArray(obj)) {
      obj.forEach(item => extractDetails(item, result));
    } else {
      Object.values(obj).forEach(value => {
        if (value && typeof value === 'object') {
          extractDetails(value, result);
        }
      });
      if (obj.category && obj.criteria) {
        result.push(obj);
      }
    }
  }
  return result;
}

const columns: Column[] = [
  { field: "leadId", header: "Lead Id", sortable: true, type: "text" },
  { field: "businessName", header: "Business Name", sortable: true, type: "text" },
  { field: "status", header: "Status", sortable: true, type: "text" },
  { field: "isrtEpoch", header: "Created Date", sortable: true, type: "date" },
   {field: "showButton", header: "", type: "text"},
  { field: "expand", header: "", expandable: true },
];


const EpochDateRenderer = (props: any) => {
  const date = new Date(props);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();
  return `${day}/${month}/${year}`;
};


const CreateLeadScoreList: FunctionComponent<any> = () => {
  const { leadList } = useData();
  const [rows, setRows] = useState<any[]>([]);
  useEffect(() => {
    const fetchData = async () => {
      if (leadList) {
        const transformedData = leadList.map((item: any) => {
          return {
            leadId: item.leadId,
            businessName: item.businessName,
            status: item.status,
            isrtEpoch: item.isrtEpoch,
            updtEpoch: EpochDateRenderer(item.updtEpoch),
            leadAndScoreDetails: [...extractDetails(item.leadAndScoreDetails), { category: "Final Score",criteria: '', score: item.finalLeadScore }],
          };
        });

        // Sort the transformedData array by isrtEpoch in descending order
        transformedData.sort((a:any, b:any) => b.isrtEpoch - a.isrtEpoch);

        setRows([...transformedData]);
      }      
    }
    fetchData();
  }, [leadList]);

  return (
    <CreateTable columns={columns} data={rows} pageSize={10} />
  )
};

export default CreateLeadScoreList;
